export const removePhoto = {
    props: {
        i18n: Object,
    },
    methods: {
        removePhoto(arr, callback = false) {
            this.$modal.show("dialog", {
                title: this.$t("threads.warning"),
                text: this.isVideo
                    ? this.$t("mixins.videoWillDeleted")
                    : this.$t("mixins.photoWillDeleted"),
                buttons: [
                    {
                        title: this.$t("myPuzzles.delete"),
                        handler: () => {
                            this.$store
                                .dispatch(
                                    (this.isVideo ? "videos" : "photos") +
                                        "/delete",
                                    arr
                                )
                                .then(() => {
                                    this.$modal.hide("dialog");
                                    if (callback) {
                                        callback();
                                    }
                                })
                                .catch(() => {
                                    this.$modal.hide("dialog");
                                });
                        },
                    },
                    {
                        title: this.$t("stories.cancel"),
                    },
                ],
            });
        },
    },
};
